<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card max-width="400">
        <v-toolbar class="black--text" :color="$store.getters.stdColorLight">
          <v-row justify="center">
            <v-toolbar-title>{{ $t("message.confirmTitle") }}</v-toolbar-title>
          </v-row>
        </v-toolbar>
        <v-card-text>
          <p>
            <span style="white-space: pre-line" v-html="this.$store.getters.confirmDialog.message"></span>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="$store.getters.stdColorDark" text @click="cancel()">{{ $t("message.cancel") }}</v-btn>
          <v-btn :color="$store.getters.stdColorDark" text @click="ok()">{{ $t("message.ok") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import WebService from "@/plugins/WebService";

export default {
  name: "optima-confirm-dialog",

  data: () => ({
    dialog: true,
    webService: null
  }),

  created() {
    this.webService = new WebService(this);
  },

  methods: {
    ok()
    {
      switch (this.$store.getters.confirmDialog.action) {
        case 'resetSchema':
          this.resetSchema();
          break;
        case 'rebuildData':
          this.rebuildData();
          break;
        case 'deleteBankkontoRecord':
          this.deleteItem([this.$store.getters.confirmDialog.params[0].nr],this.$store.getters.bankkontoBase,"setBankkontoList");
          break;
        case 'deleteMahntextRecord':
          this.deleteItem([this.$store.getters.confirmDialog.params[0].code],this.$store.getters.mahntextBase,"setMahntextList");
          break;
        case 'deleteRabattRecord':
          this.deleteItem([this.$store.getters.confirmDialog.params[0].code],this.$store.getters.rabatteBase,"setRabattList");
          break;
        case 'deleteKonditionRecord':
          this.deleteItem([this.$store.getters.confirmDialog.params[0].code],this.$store.getters.konditionenBase,"setKonditionList");
          break;
        case 'deleteFzeileRecord':
          this.deleteItem([this.$store.getters.confirmDialog.params[0].code],this.$store.getters.fzeileBase,"setFzeileList");
          break;
        case 'deleteTaxRecord':
          this.deleteItem([this.$store.getters.confirmDialog.params[0].code],this.$store.getters.taxesBase,"setTaxList");
          break;
        case 'deleteWgruppeRecord':
          this.deleteItem([this.$store.getters.confirmDialog.params[0].nr],this.$store.getters.wgruppenBase,"setWgruppenList");
          break;
        case 'deleteServiceRecord':
          this.deleteItem([this.$store.getters.confirmDialog.params[0].nr],this.$store.getters.servicesBase,"setServiceList");
          break;
        case 'deleteProductRecord':
          this.deleteItem([this.$store.getters.confirmDialog.params[0].nr],this.$store.getters.productsBase,"setProductList");
          break;
        case 'deleteCustomerRecord':
          this.deleteItem([this.$store.getters.confirmDialog.params[0].nr],this.$store.getters.customersBase,"setCustomerList");
          break;
        case 'deleteLieferantRecord':
          this.deleteItem([this.$store.getters.confirmDialog.params[0].nr],this.$store.getters.lieferantBase,"setLieferantenList");
          break;
        case 'deleteLieferadresseRecord':
          this.deleteItem([this.$store.getters.confirmDialog.params[0].nr,this.$store.getters.confirmDialog.params[0].kundenNr],this.$store.getters.lieferadresseBase,"setLieferadresseList");
          break;
        case 'deleteWeingangRecord':
          this.deleteItem([this.$store.getters.confirmDialog.params[0].nr],this.$store.getters.weingangBase,"setWeingangList");
          break;
        case 'deleteUserRecord':
          this.deleteItem([this.$store.getters.confirmDialog.params[0].mid],this.$store.getters.userBase,"setUserList");
          break;
        case 'deleteFakturaRecord':
          this.deleteFakturaItem([this.$store.getters.confirmDialog.params[0].fakturaKopf.nr,this.$store.getters.confirmDialog.params[0].fakturaKopf.typ]);
          break;
        default:
          console.log('wrong delete param');
      }

      this.$store.dispatch("setConfirmDialog", { showConfirmDialog: false, message: "", action: null, params: [] });
      this.dialog=false;
    },

    cancel()
    {
      this.$store.dispatch("setConfirmDialog", { showConfirmDialog: false, message: "", action: null, params: [] });
      this.dialog=false;
    },

    resetSchema()
    {
      this.webService.resetSchema(this.$store.getters.resetSchema)
        // eslint-disable-next-line
        .then(response => {
        })
        .catch(err => { console.log(err) });
    },

    rebuildData()
    {
      this.webService.rebuildData(this.$store.getters.rebuildData)
        // eslint-disable-next-line
        .then(response => {
        })
        .catch(err => { console.log(err) });
    },

    deleteItem(keys,restapi,vuexsetter)
    {
      this.webService.deleteItem(restapi, keys)
        .then(response => {
          if ((response.data.sqlCode==0) && (response.data.myErrorCode==0))
          {
            if (keys.length==1)
            {
              //re-read data
              this.webService.getItems(restapi)
                .then(response => {
                  this.$store.dispatch(vuexsetter, response.data);
                })
                .catch(err => { console.log(err) });
            }
            else
            {
              //re-read data master-detail
              this.webService.getChildItems(restapi,[keys[1]])
                .then(response => {
                  this.$store.dispatch(vuexsetter, response.data);
                })
                .catch(err => { console.log(err) });
            }
          }
          else
          {
            this.$store.dispatch("setErrorDialog", { sqlCode: response.data.sqlCode, sqlState: response.data.sqlState, sqlMessage: response.data.sqlMessage, myErrorCode: response.data.myErrorCode, showErrorDialog: true });
          }
        })
        .catch(err => { console.log(err) });
    },

    deleteFakturaItem(keys)
    {
      this.webService.deleteItem(this.$store.getters.fakturaBase, keys[0])
        .then(response => {
          if ((response.data.sqlCode==0) && (response.data.myErrorCode==0))
          {
            //re-read data
            this.webService.getItems(this.$store.getters.fakturaEntities+"/"+keys[1].toString())
              .then(response => {
                this.$store.dispatch("setFakturaList", response.data);
              })
              .catch(err => { console.log(err) });
          }
          else
          {
            this.$store.dispatch("setErrorDialog", { sqlCode: response.data.sqlCode, sqlState: response.data.sqlState, sqlMessage: response.data.sqlMessage, myErrorCode: response.data.myErrorCode, showErrorDialog: true });
          }
        })
        .catch(err => { console.log(err) });
    }

  }

};
</script>

<style scoped>
</style>
